import { useEffect } from 'react';

/**
 * BUG-168: stop the browser from opening a file when it is dropped OUTSIDE an
 * explicit Dropzone — e.g. onto the catalog list, which has no dropzone. The
 * browser's default action for an unhandled file drop is to navigate to the
 * file, so dragging an audio track onto the page replaces the admin SPA with
 * the browser's built-in audio player.
 *
 * The guard only suppresses the default for drags that carry OS files
 * (`dataTransfer.types` includes `'Files'`). In-page drag-and-drop (dnd-kit
 * sorting, upload reordering) carries no files and is left untouched. Real
 * Dropzone components keep working: their own element `onDrop` handlers run on
 * the drop target before the event bubbles to this window-level listener.
 */
export function useGlobalFileDropGuard(): void {
  useEffect(() => {
    const isFileDrag = (e: DragEvent) =>
      !!e.dataTransfer && Array.from(e.dataTransfer.types).includes('Files');
    const onDragOver = (e: DragEvent) => {
      if (isFileDrag(e)) e.preventDefault();
    };
    const onDrop = (e: DragEvent) => {
      // Only block drops that landed on the bare document — if a Dropzone (or
      // any element handler) already handled it, `defaultPrevented` is set.
      if (isFileDrag(e) && !e.defaultPrevented) e.preventDefault();
    };
    window.addEventListener('dragover', onDragOver);
    window.addEventListener('drop', onDrop);
    return () => {
      window.removeEventListener('dragover', onDragOver);
      window.removeEventListener('drop', onDrop);
    };
  }, []);
}
